const de = {
  // Navigation
  "nav.home": "Startseite",
  "nav.about": "Über uns",
  "nav.tokenomics": "Tokenomics",
  "nav.roadmap": "Roadmap",
  "nav.staking": "Staking",
  "nav.vesting": "Vesting",
  "nav.devupdates": "Updates",
  "nav.fwb": "FWB",
  "nav.tokensale": "Token-Verkauf",
  
  // Common sections
  "common.learnMore": "Mehr erfahren",
  "common.buyNow": "Jetzt kaufen",
  "common.contactUs": "Kontaktieren Sie uns",
  "common.loading": "Wird geladen",
  
  // Home page
  "home.hero.title": "Die Evolution des digitalen Zahlungsverkehrs",
  "home.hero.subtitle": "eDOP Token: Der Utility-Token für das Finanzökosystem der Dominikanischen Republik",
  "home.hero.cta": "Am Vorverkauf teilnehmen",
  
  // Blasen auf der Startseite
  "bubbles.home.revolution.title": "eDOP: Marktrevolution",
  "bubbles.home.revolution.content": "Der eDOP-Token zielt darauf ab, eine effiziente und zugängliche digitale Alternative im Kryptowährungsökosystem zu bieten, mit einem anfänglichen Fokus auf Schwellenmärkte und einer Vision der globalen Adoption.",
  
  "bubbles.home.ecosystem.title": "Das eDOP-Ökosystem",
  "bubbles.home.ecosystem.content": "Verpassen Sie nicht die Gelegenheit, Teil der nächsten Generation von Blockchain-Lösungen in der Krypto-Welt zu sein.",
  
  // Schaltflächen und zusätzliche Texte
  "cta.whitepaper": "Whitepaper",
  "home.title": "eDOP: Digitale Revolution",
  
  // About
  "about.title": "Über eDOP Token",
  "about.description": "eDOP Token ist ein digitaler Token, der entwickelt wurde, um den Zahlungsverkehr in der Dominikanischen Republik zu revolutionieren",
  
  // Über uns Seite
  "about.page.title": "Über Uns",
  
  // Über uns Seite Bubbles
  "bubbles.about.edop.title": "Über eDOP",
  "bubbles.about.edop.content": "eDOP ist eine effiziente und zugängliche digitale Alternative im Krypto-Ökosystem, entwickelt um Probleme des finanziellen Zugangs zu lösen, besonders in Schwellenmärkten. Es integriert Benutzerfreundlichkeit mit Sicherheit und strebt eine globale Akzeptanz an.",
  
  "bubbles.about.mission.title": "Unsere Mission",
  "bubbles.about.mission.content": "Den Zugang zu digitalen Finanzdienstleistungen zu demokratisieren, indem wir zugängliche Werkzeuge anbieten, die es Menschen ermöglichen, die Kontrolle über ihre Finanzen ohne kostspielige Zwischenhändler zu übernehmen.",
  
  "bubbles.about.transparency.title": "Transparenz",
  "bubbles.about.transparency.content": "Alle Transaktionen werden unveränderlich auf der Blockchain aufgezeichnet, was absolute Transparenz garantiert. Darüber hinaus verpflichten wir uns, die Ergebnisse der Sicherheitsaudits zu veröffentlichen, um Vertrauen zu schaffen.",
  
  "bubbles.about.innovation.title": "Innovation",
  "bubbles.about.innovation.content": "Wir innovieren, indem wir eine nutzerzentrierte Kryptolösung für finanzielle Inklusion anbieten, mit einem Ökosystem, das kostengünstige Zahlungen, Anreize und zukünftige Entwicklungen wie einen eigenen DEX und eine mobile Anwendung umfasst.",
  
  "bubbles.about.community.title": "Gemeinschaft",
  "bubbles.about.community.content": "Wir fördern eine engagierte Gemeinschaft durch ein Anreizsystem, das Teilnahme, Staking und aktive Nutzung des Ökosystems belohnt, und streben eine ausgewogene Verteilung und Erweiterung unserer Nutzerbasis an.",
  
  "bubbles.about.team.title": "Unser Team",
  "bubbles.about.team.content": "Wir haben ein multidisziplinäres Team mit umfangreicher Erfahrung in digitalen Finanzen, Blockchain-Entwicklung und Schwellenmärkten, unterstützt von strategischen Beratern in Schlüsselbereichen wie Regulierung und Wirtschaft.",
  
  "bubbles.about.technology.title": "Unsere Technologie",
  "bubbles.about.technology.content": "eDOP ist ein BEP-20 Token, der auf der BNB Smart Chain (BSC) operiert, gewählt für ihr optimales Gleichgewicht zwischen Geschwindigkeit, Sicherheit und erschwinglichen Kosten, mit Smart Contracts, die nach Best Practices entwickelt wurden.",
  
  "bubbles.about.speed.title": "Geschwindigkeit",
  "bubbles.about.speed.content": "Dank der BNB Smart Chain werden Transaktionen mit eDOP Token schnell bestätigt, typischerweise zwischen 3 und 15 Sekunden, was eine überlegene Effizienz gegenüber traditionellen Systemen und anderen Blockchains bietet.",
  
  "bubbles.about.lowcost.title": "Niedrige Kosten",
  "bubbles.about.lowcost.content": "eDOP bietet drastisch reduzierte Gebühren, die zwischen 0% und 1% pro Transaktion liegen, verglichen mit 5% bis 10% für traditionelle Überweisungsdienste. Dies wird durch die Nutzung des effizienten BNB Smart Chain-Netzwerks, optimierte Smart Contracts und die Beseitigung von Zwischenhändlern erreicht, was erschwingliche Transaktionen auch für Mikrozahlungen ermöglicht.",
  
  "bubbles.about.security.title": "Sicherheit und Kontakt",
  "bubbles.about.security.content": "Sicherheit hat Priorität, durch die Implementierung von Verträgen, die von anerkannten Firmen geprüft wurden, bewährte Tools (OpenZeppelin), Multi-Signatur-Systeme und ständige Überwachung. Für Anfragen kontaktieren Sie uns unter info@edoptoken.com, admin@edoptoken.com oder über unsere offiziellen sozialen Netzwerke, die auf unserer Website veröffentlicht sind.",
  
  // Tokenomics
  "tokenomics.title": "Token-Verteilung",
  "tokenomics.supply": "Gesamtangebot",
  
  // Tokenomics Seite
  "tokenomics.page.title": "Tokenomics",
  "tokenomics.page.subtitle": "Verteilung und Wirtschaft des eDOP Tokens",
  
  "tokenomics.intro.title": "Tokenomics",
  "tokenomics.intro.content": "Inhalt: Der eDOP Token hat ein festes Gesamtangebot von 1 Milliarde Einheiten (1.000.000.000 eDOP). Seine wirtschaftliche Gestaltung umfasst eine strategische Verteilung, um die frühe Teilnahme zu fördern, langfristige Nutzer durch Staking zu belohnen, Marktliquidität zu sichern und die kontinuierliche Entwicklung und Akzeptanz des Ökosystems zu finanzieren.",
  
  "tokenomics.distribution.title": "Token-Verteilung",
  "tokenomics.distribution.content": "Das Gesamtangebot von 1 Milliarde eDOP wird wie folgt zugeteilt:",
  "tokenomics.distribution.items": [
    "40% Öffentlicher Vorverkauf: Für frühe Nutzer.",
    "30% Staking-Belohnungen: Verteilt über 2 Jahre, um Halter zu belohnen.",
    "10% Liquidität: Für mindestens 10 Jahre oder dauerhaft gesperrt für Stabilität.",
    "10% Marketing und Adoption: Für Wachstum und Outreach.",
    "5% Entwicklung: Mit schrittweiser Freigabe für das Team (Vesting).",
    "5% Chain-Inventar: Für technische Operationen des Ökosystems."
  ],
  
  "tokenomics.purpose.title": "eDOP: Ein Token mit Zweck",
  "tokenomics.purpose.content": "Mit einem begrenzten Gesamtangebot von 1 Milliarde Einheiten ist der eDOP Token so konzipiert, dass er nützlich und nachhaltig ist. Seine strategische Verteilung sichert Mittel für Staking-Belohnungen (30%), langfristige Liquidität (10%) und Wachstum. In erster Linie können Sie eDOP als effizientes und kostengünstiges Zahlungsmittel verwenden oder es sperren (Staking), um Belohnungen und zusätzliche Vorteile in unserem digitalen Finanzökosystem zu erhalten.",
  
  "tokenomics.utility.title": "Token-Nutzen",
  "tokenomics.utility.items": [
    "Governance: eDOP-Inhaber können über wichtige Vorschläge abstimmen, die die Entwicklung und Ausrichtung des Projekts beeinflussen.",
    "Staking: Erhalten Sie bedeutende Belohnungen durch das Staking Ihrer Tokens, mit wettbewerbsfähigen jährlichen Raten.",
    "Reduzierte Gebühren: Benutzer, die eDOP besitzen, genießen reduzierte Gebühren bei allen Transaktionen innerhalb der Plattform.",
    "Zugang zu exklusiven Funktionen: Schalten Sie erweiterte Funktionen und Tools innerhalb unserer Plattform frei.",
    "Zahlungsmittel: Verwenden Sie eDOP für schnelle und wirtschaftliche Transaktionen innerhalb unseres Ökosystems."
  ],
  
  // Token sale
  "tokensale.title": "Token-Verkauf",
  "tokensale.subtitle": "Nehmen Sie an unserem Vorverkauf teil",
  "tokensale.price": "Aktueller Preis",
  "tokensale.connect": "Wallet verbinden",
  
  // Footer
  "footer.rights": "Alle Rechte vorbehalten",
  "footer.terms": "Geschäftsbedingungen",
  "footer.privacy": "Datenschutzrichtlinie",
  "footer.fwb": "Freunde mit Vorteilen",
  
  // Wallet
  "wallet.connect": "Wallet verbinden",
  
  // News
  "news.label": "NACHRICHTEN",
  
  // Datenschutzrichtlinie Seite
  "privacy.page.title": "Datenschutzrichtlinie",
  
  // Datenschutzrichtlinie Blasen
  "bubbles.privacy.commitment.title": "Unser Engagement für Ihre Privatsphäre",
  "bubbles.privacy.commitment.content": "Bei eDOP Token verpflichten wir uns zu vollständiger Transparenz und zum Schutz Ihrer Daten. Als Projekt, das sich auf die Demokratisierung des Zugangs zu digitalen Finanzdienstleistungen konzentriert, verstehen wir die Bedeutung von Vertrauen.",
  
  "bubbles.privacy.nocollection.title": "Wir Sammeln Keine Informationen",
  "bubbles.privacy.nocollection.content": "Um unsere Mission der finanziellen Inklusion zu erfüllen, fordern wir niemals Identifikationsdaten an. Vermeiden Sie, Opfer von Phishing zu werden, und geben Sie niemals Ihre privaten Schlüssel oder Seed-Phrasen preis - eDOP Token wird Sie niemals danach fragen, denken Sie daran.",
  
  "bubbles.privacy.usage.title": "Wie Wir Ihre Informationen Verwenden",
  "bubbles.privacy.usage.content": "Wir sammeln keine persönlichen Daten oder Informationen. Wir verwenden nur Ihre Wallet-Adresse für Operationen, technische Daten zur Aufrechterhaltung der Plattformsicherheit und optional einige Details, die Ihre Erfahrung verbessern. Alles unter guten Praktiken und ohne Informationen an Dritte weiterzugeben.",
  
  "bubbles.privacy.security.title": "Sicherheit und Schutz",
  "bubbles.privacy.security.content": "Wir wenden die gleichen Sicherheitsmaßnahmen an, die unsere Smart Contracts schützen: OpenZeppelin-Protokolle, Multi-Signatur bei Schlüsseloperationen, Limits zur Risikominderung und ständige Überwachung. Alles ist mit unseren Audits abgestimmt und gewährleistet die Sicherheit Ihrer Daten und digitalen Assets.",
  
  // Freunde mit Vorteilen (FWB) Seite
  "fwb.page.title": "Freunde mit Vorteilen (FWB)",
  
  // FWB Seite Blasen
  "bubbles.fwb.community.title": "eDOP Gemeinschaft (FWB)",
  "bubbles.fwb.community.content": "Bei eDOP glauben wir an eine globale Gemeinschaft, die den finanziellen Zugang demokratisieren möchte. Unser Ökosystem ist darauf ausgelegt, dass Nutzer die Kontrolle übernehmen und an einer gerechteren digitalen Wirtschaft zusammenarbeiten, insbesondere in Schwellenmärkten.",
  
  "bubbles.fwb.join.title": "Wie man beitritt und teilnimmt",
  "bubbles.fwb.join.content": "Werden Sie ein aktiver Teil von eDOP, indem Sie den Token für Zahlungen verwenden, an unserem Staking-Programm teilnehmen, um das Netzwerk zu unterstützen, und sich darauf vorbereiten, zur zukünftigen Steuerung des Ökosystems beizutragen. Ihre Teilnahme ist der Schlüssel zu unserem Wachstum.",
  "bubbles.fwb.join.date": "Datum: 04. April 2025",
  
  "bubbles.fwb.benefits.title": "Vorteile der eDOP-Gemeinschaft",
  "bubbles.fwb.benefits.content": "Durch die Teilnahme an eDOP können Sie regelmäßige Belohnungen durch Staking erhalten (aus 30% des zugewiesenen Gesamtangebots). Zusätzlich kann aktives Halten Ihnen Zugang zu Vorteilen wie Gebührenermäßigungen oder Priorität bei neuen Ökosystem-Funktionen verschaffen.",
  
  "bubbles.fwb.connect.title": "Verbinden Sie sich mit der Gemeinschaft",
  "bubbles.fwb.connect.content": "Bleiben Sie informiert und mit dem eDOP-Projekt verbunden. Finden Sie Links zu unseren offiziellen Gemeinschaftskanälen, technischer Dokumentation und Kontaktmöglichkeiten direkt auf unserer offiziellen Website.",
  
  // Allgemeine Geschäftsbedingungen Seite
  "terms.page.title": "Allgemeine Geschäftsbedingungen",
  
  // Blasen der AGB-Seite
  "bubbles.terms.risk.title": "Risikohinweise:",
  "bubbles.terms.risk.content": "Die Investition in eDOP Token beinhaltet erhebliche Risiken, einschließlich hoher Volatilität und des möglichen vollständigen oder teilweisen Kapitalverlusts. Der Wert des Tokens hängt vom Markt ab, es gibt keine Rentabilitätsgarantie, und digitale Vermögenswerte haben keine Einlagensicherung. Berücksichtigen Sie sorgfältig Ihre Risikotoleranz, bevor Sie investieren.",
  
  "bubbles.terms.liability.title": "Haftungsbeschränkung",
  "bubbles.terms.liability.content": "Die Performance des eDOP Tokens unterliegt Marktrisiken, die außerhalb der Kontrolle des Emittenten liegen (Servicios de Desarrollo de Algoritmos y Consultoría de Technologie Blockchain, SRL). Wir sind nicht verantwortlich für Verluste, die aus Volatilität, Liquiditätsschwankungen oder Risiken resultieren, die mit der Investition in digitale Vermögenswerte verbunden sind.",
  
  "bubbles.terms.issuer.title": "Emittent und rechtliche Konformität",
  "bubbles.terms.issuer.content": "eDOP Token wird von Servicios de Desarrollo de Algoritmos y Consultoría de Technologie Blockchain, SRL ausgegeben, einer rechtlich etablierten Einheit. Wir bemühen uns, in Übereinstimmung mit den geltenden Vorschriften zu arbeiten und verfügen über rechtliche Beratung zu digitalen Vermögenswerten und Finanzrecht.",
  
  "bubbles.terms.contact.title": "Kontakt",
  "bubbles.terms.contact.content": "Für Anfragen zu diesen Bedingungen, dem eDOP Token-Projekt oder für weitere Informationen können Sie sich an unsere E-Mail wenden: oder zusätzliche Ressourcen auf unserer Website konsultieren.",
  
  // Entwicklungsupdates-Seite
  "devupdates.page.title": "Entwicklungsupdates",
  
  // Blasen der Entwicklungsupdates-Seite
  "bubbles.devupdates.intro.title": "Entwicklungsupdates",
  "bubbles.devupdates.intro.content": "Gemäß dem im Whitepaper beschriebenen technischen Plan konzentriert sich die Entwicklung von eDOP auf die Erstellung wichtiger Komponenten wie eine kostengünstige Zahlungsplattform, eine zukünftige eigene dezentrale Börse (DEX) und eine mobile Anwendung. Das gesamte Ökosystem ist für den Betrieb auf der BNB Smart Chain konzipiert und sucht ein Gleichgewicht zwischen Effizienz, Sicherheit und Zugänglichkeit.",
  
  "bubbles.devupdates.latest.title": "Neueste Updates",
  "bubbles.devupdates.latest.content": "Basierend auf dem ursprünglichen Whitepaper-Plan und in Vorbereitung auf unsere Phase 1 (voraussichtlich Ende Q2 2025) umfasst unser aktueller Fokus die Vorbereitungen für den Token-Launch, die Aktivierung der Zahlungsplattform und die Sicherung erster Börsenlistings. Für den tatsächlichen Fortschritt und bestätigte Ankündigungen überprüfen Sie bitte immer unsere offiziellen Kanäle.",
  "bubbles.devupdates.latest.date": "Datum: 28. April 2025",
  
  "bubbles.devupdates.events.title": "Kommende Community-Veranstaltungen",
  "bubbles.devupdates.events.content": "Unsere Gemeinschaft wird einen Plan für aktive Community-Interaktion erstellen, mit Strategien wie regelmäßigen Bildungs-Webinaren und Präsenz bei wichtigen Branchenveranstaltungen. Obwohl im Dokument keine Termine für kommende AMA-Sitzungen oder andere spezifische Veranstaltungen angegeben sind, besteht unser Engagement darin, eine flüssige und informative Kommunikation aufrechtzuerhalten.",
  "bubbles.devupdates.events.date": "Datum: 28. April 2025",
  
  "bubbles.devupdates.technical.title": "Technisches Update: Smart Contract Audit",
  "bubbles.devupdates.technical.content": "Gemäß unserem im Whitepaper beschriebenen Sicherheitsansatz besteht die Verpflichtung, die Smart Contracts von eDOP Token vor dem Start von anerkannten externen Firmen (Beispiele wie CertiK oder Hacken werden erwähnt) prüfen zu lassen. Diese Auditberichte sollen für vollständige Transparenz mit der Community auf unserer Website veröffentlicht werden.",
  "bubbles.devupdates.technical.date": "Datum: 28. April 2025",
  
  "bubbles.devupdates.partnership.title": "Ankündigung strategischer Partnerschaften",
  "bubbles.devupdates.partnership.content": "Unser Whitepaper legt die Strategie und die Bedeutung der Bildung strategischer Allianzen für das Wachstum und den Nutzen des eDOP Tokens fest und erwähnt Pläne zur Zusammenarbeit mit Händlern, insbesondere in Schwellenmärkten. Das Gründungsdokument enthält jedoch keine spezifischen Ankündigungen bereits unterzeichneter Partnerschaften; es beschreibt die Absicht und den Ansatz, sie als Teil des Fahrplans zu suchen.",
  "bubbles.devupdates.partnership.date": "Datum: 28. April 2025",
  
  "bubbles.devupdates.previous.title": "Frühere Updates",
  "bubbles.devupdates.previous.content1": "Das Whitepaper dient als anfänglicher Masterplan und Präsentation des eDOP Token-Projekts. Aufgrund seiner Natur werden frühere Updates oder bereits abgeschlossene Meilensteine seit seiner Veröffentlichung in den offiziellen Kanälen zur Information erscheinen.",
  "bubbles.devupdates.previous.content2": "Um auf ein Archiv früherer Nachrichten, Fortschritte und Ankündigungen zuzugreifen, gehen Sie bitte zu den Nachrichten/Blog-Bereichen oder historischen Kanälen in den offiziellen sozialen Netzwerken von eDOP. Kommen Sie hierher zurück, um alle unsere früheren Updates zu sehen!",

  // Roadmap Page
  "roadmap.page.title": "Entwicklungsfahrplan",
  "roadmap.page.subtitle": "Unsere Vision und Meilensteine für die Zukunft",

  // Roadmap Phases
  "roadmap.phase1.title": "Phase 1: Grundlagen und Start",
  "roadmap.phase1.description": "Entwicklung der Token-Grundlagen und Start des Vorverkaufs",
  "roadmap.phase1.items": [
    "Smart Contract-Entwicklung und Audit",
    "Token-Vorverkauf",
    "Community-Aufbau",
    "Website-Launch"
  ],

  "roadmap.phase2.title": "Phase 2: Markteinführung und Expansion",
  "roadmap.phase2.description": "DEX-Listings und Beginn der Marketingkampagnen",
  "roadmap.phase2.items": [
    "DEX-Listings",
    "Marketing-Kampagnen",
    "Partnerschaften",
    "Community-Wachstum"
  ],

  "roadmap.phase3.title": "Phase 3: Produktentwicklung",
  "roadmap.phase3.description": "Entwicklung der Zahlungsplattform und Wallet-Integration",
  "roadmap.phase3.items": [
    "Zahlungsplattform-Beta",
    "Wallet-Integration",
    "Händler-Onboarding",
    "Sicherheitsaudits"
  ],

  "roadmap.phase4.title": "Phase 4: Ökosystem-Erweiterung",
  "roadmap.phase4.description": "Erweiterung des Ökosystems und neue Funktionen",
  "roadmap.phase4.items": [
    "Mobile App-Launch",
    "Cross-Chain-Integration",
    "Governance-Implementation",
    "Neue Partnerschaften"
  ],

  // Roadmap Status
  "roadmap.status.completed": "Abgeschlossen",
  "roadmap.status.inProgress": "In Bearbeitung",
  "roadmap.status.upcoming": "Geplant",

  // Roadmap Additional Sections
  "roadmap.vision.title": "Unsere Vision",
  "roadmap.vision.content": "Die Zukunft des digitalen Zahlungsverkehrs in der Dominikanischen Republik und darüber hinaus gestalten",

  "roadmap.updates.title": "Aktuelle Updates",
  "roadmap.updates.content": "Bleiben Sie über unseren Fortschritt auf dem Laufenden",

  // Vesting Seite
  "vesting.page.title": "eDOP Vesting-Plattform",
  
  // Vesting Seite - Blasen
  "bubbles.vesting.platform.title": "eDOP Vesting-Plattform",
  "bubbles.vesting.platform.content": "Tokens, die für das Entwicklungsteam bestimmt sind (5% der Gesamtmenge), werden nicht auf einmal ausgegeben. Zuerst werden sie für 120 Tage vollständig gesperrt. Danach erhält das Team jeden Monat einen kleinen Teil (linear 2% ihrer Zuteilung). Dieser Prozess wird als Vesting bezeichnet und stellt sicher, dass das Team langfristig dem eDOP Token-Projekt verpflichtet bleibt.",
  
  "bubbles.vesting.emission.title": "Schrittweise Token-Ausgabe",
  "bubbles.vesting.emission.content": "eDOP kontrolliert die langsame Freigabe von Tokens durch Vesting für das Team und die schrittweise Verteilung von Staking-Belohnungen (30% über 2 Jahre). Diese kontrollierte Emission soll starke Preisrückgänge vermeiden und die Token-Zirkulation mit dem Projektwachstum in Einklang bringen.",

  // VestingBox4 Komponente
  "vestingBox4.claimedTokens": "Beanspruchte Tokens",
  "vestingBox4.loading": "Lädt...",
  "vestingBox4.availableToClaim": "Verfügbar zum Beanspruchen",
  "vestingBox4.processing": "Verarbeitung...",
  "vestingBox4.claimTokens": "Tokens beanspruchen",
  "vestingBox4.successTransaction": "Transaktion erfolgreich!",
  "vestingBox4.claimSuccess": "Sie haben {{amount}} $eDOP erfolgreich beansprucht.",
  "vestingBox4.viewTransaction": "Transaktion anzeigen",
  "vestingBox4.close": "Schließen",
  "vestingBox4.noTokensAvailable": "Sie haben keine Tokens zum Beanspruchen verfügbar",
  "vestingBox4.claimError": "Fehler beim Beanspruchen von Tokens:",
  "vestingBox4.unknownError": "Unbekannter Fehler",

  // VestingBox3 Komponente
  "vestingBox3.calendar": "Vesting-Kalender",
  "vestingBox3.start": "Start",
  "vestingBox3.end": "Ende",
  "vestingBox3.cliffPeriod": "Cliff-Periode",
  "vestingBox3.loading": "Wird geladen...",
  "vestingBox3.days": "Tage",
  "vestingBox3.progress": "Fortschritt",
  "vestingBox3.viewDetailedCalendar": "Detaillierten Kalender anzeigen",
  "vestingBox3.vestingStart": "Vesting-Start",
  "vestingBox3.cliffEnd": "Ende der Cliff-Periode",
  "vestingBox3.vestingEnd": "Vesting-Ende",
  "vestingBox3.weeklyReleases": "Wöchentliche Freigaben",
  "vestingBox3.releaseDescription": "Nach der 90-tägigen Cliff-Periode werden Ihre Tokens wöchentlich mit 1% über etwa 2 Jahre freigegeben.",
  "vestingBox3.close": "Schließen",

  // VestingBox2 Komponente
  "vestingBox2.nextRelease": "Nächste Freigabe",
  "vestingBox2.noVesting": "Kein Vesting",
  "vestingBox2.loading": "Wird geladen...",
  "vestingBox2.notScheduled": "Nicht geplant",
  "vestingBox2.availableNow": "Jetzt verfügbar",
  "vestingBox2.days": "Tag(e)",
  "vestingBox2.hours": "Std",
  "vestingBox2.minutes": "Min",
  "vestingBox2.amountToRelease": "Freizugebender Betrag",
  "vestingBox2.claimAvailableTokens": "Verfügbare Token beanspruchen",

  // VestingBox1 Komponente
  "vestingBox1.yourVesting": "Ihr Vesting",
  "vestingBox1.lockedTokens": "Gesperrte Tokens",
  "vestingBox1.viewDetails": "DETAILS ANZEIGEN",
  "vestingBox1.loading": "Lädt...",
  "vestingBox1.infoModal.title": "Vesting-Informationen",
  "vestingBox1.infoModal.content": "Vesting ist ein Zeitraum, in dem Ihre Tokens schrittweise freigegeben werden. \"Gesperrte Tokens\" stellen die Menge an Tokens dar, die noch nicht freigegeben wurden und noch nicht beansprucht werden können.",
  "vestingBox1.infoModal.understood": "Verstanden",

  // Staking Seite
  "staking.page.title": "eDOP Staking-Plattform",
  
  // Staking Blasen
  "bubbles.staking.platform.title": "eDOP Staking-Plattform",
  "bubbles.staking.platform.content": "Es ist die Funktion innerhalb von eDOP, bei der Sie Ihre Tokens sperren können, um das Projekt zu unterstützen. Im Austausch für die Sperrung erhalten Sie Belohnungen (mehr eDOP Token).",
  
  "bubbles.staking.benefits.title": "Vorteile des Stakings",
  "bubbles.staking.benefits.items": [
    "Verdienen Sie mehr eDOP: Sie erhalten zusätzliche Tokens als Belohnung für das Sperren Ihrer eigenen.",
    "Nehmen Sie an Entscheidungen teil: Es gibt Ihnen die Möglichkeit, über die Zukunft des Projekts abzustimmen oder sie zu beeinflussen.",
    "Unterstützen Sie den Token: Sie helfen dabei, den Wert des Tokens langfristig stabiler zu machen."
  ],
  
  "bubbles.staking.rewards.title": "Belohnungen",
  "bubbles.staking.rewards.content": "Sie können Ihre angesammelten Belohnungen einfordern, sobald die Auszahlungsfunktion auf der Plattform aktiv ist.",
  
  // StakingBox4 Komponente
  "stakingBox4.totalRewards": "GESAMTBELOHNUNGEN",
  "stakingBox4.claimRewards": "Belohnungen beanspruchen",
  "stakingBox4.processing": "Verarbeitung...",
  "stakingBox4.claimed": "Beansprucht",
  "stakingBox4.success": "Erfolg!",
  "stakingBox4.info": "INFO",
  "stakingBox4.accept": "Akzeptieren",
  "stakingBox4.noRewards": "Keine Belohnungen zum Beanspruchen verfügbar",
  "stakingBox4.claimedSuccess": "Belohnungen erfolgreich beansprucht! Sie haben {{amount}} $eDOP erhalten",
  "stakingBox4.errorClaiming": "Belohnungen konnten nicht beansprucht werden",
  "stakingBox4.userRejected": "Die Transaktion wurde vom Benutzer abgelehnt",
  "stakingBox4.insufficientFunds": "Unzureichende Mittel für die Durchführung der Transaktion",
  "stakingBox4.contractRejection": "Die Transaktion wurde vom Smart Contract abgelehnt",
  
  // StakingBox3 Komponente
  "stakingBox3.estimatedRewards": "GESCHÄTZTE BELOHNUNGEN",
  "stakingBox3.rewardsDynamic": "• Der Belohnungsprozentsatz ist dynamisch",
  "stakingBox3.monthly": "• Monatlich = {{rate}}%",
  "stakingBox3.daily": "• Täglich = {{rate}}%",

  // StakingBox2 Komponente
  "stakingBox2.poolPercentage": "POOL-PROZENTSATZ",
  "stakingBox2.stakedBalance": "STAKING-GUTHABEN",
  "stakingBox2.processing": "Verarbeitung...",
  "stakingBox2.withdrawTokens": "Tokens abheben",
  "stakingBox2.success": "Erfolg!",
  "stakingBox2.info": "INFO",
  "stakingBox2.accept": "Akzeptieren",
  "stakingBox2.tokensWithdrawn": "Tokens erfolgreich abgehoben",
  "stakingBox2.errorWithdrawing": "Tokens konnten nicht abgehoben werden",
  "stakingBox2.userRejected": "Die Transaktion wurde vom Benutzer abgelehnt",
  "stakingBox2.insufficientFunds": "Unzureichende Mittel für die Durchführung der Transaktion",
  "stakingBox2.contractRejection": "Die Transaktion wurde vom Smart Contract abgelehnt",
  "stakingBox2.infoModal.title": "Pool-Prozentsatz",
  "stakingBox2.infoModal.content": "Dieser Prozentsatz stellt das Verhältnis Ihrer gestakten Tokens im Vergleich zu den gesamten Tokens im Staking dar. Je höher Ihr Prozentsatz ist, desto höher ist der Anteil der Belohnungen, die Sie erhalten werden.",
  "stakingBox2.infoModal.understood": "Verstanden",
  
  // StakingBox1 Komponente
  "stakingBox1.stakedBalance": "STAKING-GUTHABEN",
  "stakingBox1.stakeable": "DEIN STAKEABLE",
  "stakingBox1.stakeNow": "JETZT STAKEN",
  "stakingBox1.success": "Erfolg!",
  "stakingBox1.info": "INFO",
  "stakingBox1.accept": "Akzeptieren",
  "stakingBox1.connectWallet": "Bitte verbinde zuerst deine Wallet",
  "stakingBox1.enterValidAmount": "Bitte gib einen gültigen Betrag ein",
  "stakingBox1.errorStaking": "Es gab ein Problem beim Staking deiner Tokens",
  "stakingBox1.userRejected": "Die Transaktion wurde vom Benutzer abgelehnt",
  "stakingBox1.insufficientFunds": "Unzureichende Mittel für die Durchführung der Transaktion",
  "stakingBox1.contractRejection": "Die Transaktion wurde vom Smart Contract abgelehnt",
  "stakingBox1.stakeTokens": "Tokens staken",
  "stakingBox1.processingTransaction": "Transaktion wird verarbeitet",
  "stakingBox1.waitForStaking": "Bitte warte, während dein Staking abgeschlossen wird...",
  "stakingBox1.transactionSuccess": "Transaktion erfolgreich!",
  "stakingBox1.successStaked": "Du hast erfolgreich {{amount}} $eDOP gestakt",
  "stakingBox1.exit": "Beenden",
  "stakingBox1.available": "Verfügbar: {{amount}}",
  "stakingBox1.confirm": "Akzeptieren",
  "stakingBox1.cancel": "Abbrechen",
  
  // StakingSupply Komponente
  "stakingSupply.title": "Gesamtes Staking-Angebot",
  "stakingSupply.totalSupply": "Gesamtangebot (Millionen)",
  
  // Abgekürzte Monate für Diagramme
  "months.jan": "Jan",
  "months.feb": "Feb",
  "months.mar": "Mär",
  "months.apr": "Apr",
  "months.may": "Mai",
  "months.jun": "Jun",
  "months.jul": "Jul",
  "months.aug": "Aug",
  "months.sep": "Sep",
  "months.oct": "Okt",
  "months.nov": "Nov",
  "months.dec": "Dez",
  
  // PresaleBox Komponente
  "presaleBox.buyMessage": "KAUFEN SIE JETZT IHRE $eDOP TOKENS",
  "presaleBox.days": "Tage",
  "presaleBox.hours": "Stunden",
  "presaleBox.minutes": "Min",
  "presaleBox.seconds": "Sek",
  "presaleBox.presalePending": "Vorverkauf beginnt bald",
  "presaleBox.presaleCompleted": "Vorverkauf abgeschlossen",
  "presaleBox.stage": "Phase {{current}} von {{total}}",
  "presaleBox.fundsRaised": "USDT gesammelt: ${{raised}} / ${{goal}}",
  "presaleBox.tokensPurchased": "Ihre gekauften eDOP Tokens: {{amount}}",
  "presaleBox.tokensStaked": "Ihre gestakten $eDOP Tokens = {{amount}}",
  "presaleBox.tokenPrice": "1 eDOP = ${{price}} USDT",
  "presaleBox.payWith": "Zahlen mit {{currency}}",
  "presaleBox.receive": "Erhalten $eDOP",
  "presaleBox.maximum": "Maximum",
  "presaleBox.insufficientFunds": "Sie haben nicht genügend {{currency}} für diese Transaktion.",
  "presaleBox.buyWithBnb": "Kaufen mit {{symbol}}",
  "presaleBox.buyWithUsdt": "Kaufen mit {{symbol}}",
  "presaleBox.buyWithCard": "Kaufen mit Karte",
  "presaleBox.goToDex": "Zum DEX",
  "presaleBox.balance": "Guthaben in {{currency}}:",
  "presaleBox.connectWallet": "Wallet verbinden",
  "presaleBox.reloadBnb": "Nicht genug BNB? Hier aufladen",
  "presaleBox.developedBy": "Entwickelt von",
  
  // Informationsmodal für PresaleBox
  "presaleBox.infoModal.title": "Achtung!",
  "presaleBox.infoModal.tokensPurchased": "Die Gesamtmenge der von Ihnen gekauften Tokens sind alle mit der verbundenen Wallet erworbenen Tokens. Dies umfasst alle gestakten und nicht gestakten Tokens.",
  "presaleBox.infoModal.ok": "OK",
  "presaleBox.infoModal.stakeableTokens": "Nicht beanspruchte $eDOP, die mit ETH oder ERC-20 USDT gekauft wurden, können jetzt zum Staking verwendet werden. Bitte beachten Sie, dass alle im frühen Staking verwendeten Tokens 7 Tage nach Aktivierung der Token-Beanspruchung zurückgezogen werden können, was nach Abschluss des Vorverkaufs erfolgen wird.",
  
  // Warnhinweise für PresaleBox
  "presaleBox.alert.connectWallet": "Bitte verbinden Sie zuerst Ihre Wallet",
  "presaleBox.alert.enterValidAmount": "Bitte geben Sie einen gültigen Betrag ein",
  "presaleBox.alert.presaleNotStarted": "Der Vorverkauf beginnt am 01. Juni 2025. Bitte warten Sie, bis der Vorverkauf beginnt.",
  "presaleBox.alert.confirmInWallet": "Bitte bestätigen Sie die Transaktion in Ihrer Wallet...",
  "presaleBox.alert.purchaseSuccess": "Kauf erfolgreich! Sie haben {{amount}} eDOP Tokens gekauft",
  "presaleBox.alert.paymentMethodNotSupported": "Zahlungsmethode nicht unterstützt",
  
  // Vereinfachte Fehler für PresaleBox
  "presaleBox.error.insufficientTokens": "Derzeit sind nicht genügend Tokens verfügbar. Bitte versuchen Sie es später erneut.",
  "presaleBox.error.userDenied": "Transaktion abgelehnt. Sie müssen die Transaktion in Ihrer Wallet bestätigen, um fortzufahren.",
  "presaleBox.error.gas": "Transaktions-Gas-Fehler. Stellen Sie sicher, dass Sie genügend BNB haben, um die Gas-Gebühren zu decken.",
  "presaleBox.error.nonce": "Fehler in der Transaktionsreihenfolge. Versuchen Sie, die Seite zu aktualisieren und es erneut zu versuchen.",
  "presaleBox.error.contractFailure": "Transaktion fehlgeschlagen. Der Vertrag könnte pausiert sein oder keine Tokens mehr verfügbar haben.",
  "presaleBox.error.generic": "Transaktionsfehler. Bitte versuchen Sie es später erneut.",
  
  // Erforderliches Netzwerk für PresaleBox
  "presaleBox.network.bnbMainnet": "BNB Smart Chain",
  "presaleBox.network.bnbTestnet": "BSC Testnet",
  "presaleBox.network.bnbBoth": "BNB Smart Chain oder BSC Testnet",
  "presaleBox.network.usdtBep20": "BNB Smart Chain (für USDT BEP-20)",
  "presaleBox.network.usdtErc20": "Ethereum (für USDT ERC-20)",
  "presaleBox.network.usdtTestnet": "BSC Testnet (für USDT Testnet)",
  "presaleBox.network.usdtOptions": "Ethereum (für USDT ERC-20) oder BNB Smart Chain (für USDT BEP-20)",
  "presaleBox.network.usdtOptionsTestnet": "Ethereum (für USDT ERC-20) oder BNB Smart Chain/Testnet (für USDT BEP-20)",
  "presaleBox.network.compatible": "kompatibles Netzwerk",
  "presaleBox.network.changeNetwork": "Um mit {{method}} zu bezahlen, müssen Sie zum {{network}}-Netzwerk wechseln",
  
  // Fehlermeldungen für Verträge
  "contracts.error.invalidConfig": "Vertrag {{contractName}} nicht richtig konfiguriert",
  "contracts.error.initialization": "Fehler bei der Initialisierung des Vertrags {{contractName}}: {{error}}",
  "contracts.error.notInitialized": "Der Vertrag ist nicht initialisiert",
  "contracts.error.walletNotConnected": "Wallet nicht verbunden. Bitte verbinden Sie Ihre Wallet, um fortzufahren",
  "contracts.error.transaction": "Transaktionsfehler: {{error}}",
  "errors.contractInitialization": "Fehler bei der Initialisierung der Verträge",
  
  // Wallet-Fehler
  "wallet.error.noMetamask": "MetaMask ist nicht installiert",
  "wallet.error.noAccount": "Konto konnte nicht abgerufen werden",
  "wallet.error.networkNotSupported": "Netzwerk nicht unterstützt",
  "wallet.error.connection": "Fehler beim Verbinden der Wallet",
  "wallet.error.networkSwitch": "Fehler beim Netzwerkwechsel",
  
  // Fehlermeldungen für den Vorverkauf
  "presale.error.connectWalletFirst": "Bitte verbinde zuerst deine Wallet",
  "presale.error.contractNotReady": "Der Vorverkaufsvertrag ist nicht bereit",
  "presale.error.noSigner": "Konnte keinen Signer erhalten. Bitte verbinde deine Wallet erneut.",
  "presale.error.priceChanged": "Preisfehler: Der Preis hat sich geändert. Bitte aktualisiere die Seite.",
  "presale.error.userRejected": "Transaktion vom Benutzer abgelehnt",
  "presale.error.insufficientFunds": "Unzureichende Mittel, um die Transaktion abzuschließen",
  "presale.error.purchaseError": "Kauffehler: {{error}}",
  "presale.error.unknown": "Unbekannt",
  "presale.error.usdtApprovalError": "USDT-Genehmigungsfehler",
  "presale.error.cannotClaimTokens": "Tokens können zu diesem Zeitpunkt nicht beansprucht werden",
  
  // Konsolennachrichten - nur für Entwickler, nicht für Benutzer sichtbar
  "console.contracts.initialized": "Vorverkaufsverträge erfolgreich initialisiert",
  "console.contracts.initError": "Fehler bei der Initialisierung der Verträge:",
  "console.tokens.availableError": "Fehler beim Laden der verfügbaren Tokens:",
  "console.exchangeRates.error": "Fehler beim Abrufen der Wechselkurse:",
  "console.price.error": "Fehler beim Abrufen des Vertragspreises:",
  "console.price.fromContract": "Preis aus dem Vertrag erhalten:",
  "console.price.contractError": "Fehler beim Abrufen des Preises aus dem Vertrag:",
  "console.price.usingFallback": "Fallback-Preis wird verwendet:",
  "console.bnb.buying": "Kauf mit BNB: {{amount}} BNB, um {{tokensToReceive}} Tokens zu erhalten",
  "console.price.perToken": "Preis pro Token: {{price}} USDT",
  "console.signer.available": "Signer verfügbar: {{available}}",
  "console.account.current": "Aktuelles Konto: {{account}}",
  "console.bnb.success": "BNB-Kauf erfolgreich:",
  "console.bnb.error": "Fehler beim Kauf mit BNB:",
  "console.usdt.approving": "USDT-Ausgaben werden genehmigt...",
  "console.price.fromContractUsdt": "Preis aus dem Vertrag erhalten (USDT):",
  "console.price.contractErrorUsdt": "Fehler beim Abrufen des Preises aus dem Vertrag (USDT):",
  "console.price.usingFallbackUsdt": "Fallback-Preis wird verwendet (USDT):",
  "console.usdt.buying": "Kauf mit USDT: {{amount}} USDT mit Preis {{price}} pro Token",
  "console.tokens.expected": "Erwartete Tokens: {{tokens}}",
  "console.usdt.success": "USDT-Kauf erfolgreich:",
  "console.usdt.error": "Fehler beim Kauf mit USDT:",
  "console.tokens.claimSuccess": "Tokens erfolgreich beansprucht:",
  "console.tokens.claimError": "Fehler beim Beanspruchen von Tokens:",
  "console.purchases.error": "Fehler beim Abrufen der Kaufdaten:",

  // Ticker-Nachrichten
  "ticker.message1": "1️⃣ Nehmen Sie am eDOP-Vorverkauf teil! 🚀 Profitieren Sie von exklusiven Preisen vor dem Launch. 🔥",
  "ticker.message2": "2️⃣ eDOP revolutioniert den Markt! 💎 Werden Sie Teil des Ökosystems und sichern Sie sich Ihren Platz in der neuen digitalen Ära. ⚡",
  "ticker.message3": "3️⃣ Letzte Tage des eDOP-Vorverkaufs! ⏳ Bleiben Sie nicht außen vor, sichern Sie sich Ihre Tokens, bevor es zu spät ist. 🎯",

  // Meta-Tags
  "meta.description": "eDOP Token - Die Währung des dominikanischen Finanzökosystems"
};

export default de;